import { z } from 'zod';

export const cardManuallyActiveSchema = z.object({
  manually_activated_reason: z.string().min(2, { message: 'Tamanho mínimo: 2 characteres' }).max(1024, { message: 'Tamanho máximo: 1024 characteres' }),
  manually_activated_reason_file: z.object({
    blob_id: z.string().optional(),
    file: z.custom<File>().optional(),
  }).optional(),
})

export type CardManuallyActiveValidationSchema = z.infer<typeof cardManuallyActiveSchema>